import { getStatusBadge } from "../utils";

const defaultProps = {
  keys: [],
};

function OutputString({ field, object, keys }) {
  const value = object[field];

  if (!value || value === "") {
    return "---";
  }

  if (
    (field === "gross" ||
      field === "net" ||
      field === "vat" ||
      field === "vatExempt" ||
      field === "zeroRated") &&
    typeof value === "string"
  ) {
    return `₱ ${value}`;
  }

  if (field === "status" && typeof value === "string") {
    return getStatusBadge(value);
  }

  if (value && typeof value !== "object") {
    return value;
  }

  const values = [];
  keys.forEach((key) => {
    const v = object[key];
    if (v && typeof v !== "object") {
      values.push(v);
    }
  });
  return values.join(" ");
}

OutputString.defaultProps = defaultProps;

export default OutputString;
